import '/app/brewery-packages/layout/grid-old/src/grid.css-raw';
export default {
  "defaultOffset10": "switch-81d9d7e1-defaultOffset10-WXUgJq",
  "tiny1": "switch-81d9d7e1-tiny1-WXUgJq",
  "default4": "switch-81d9d7e1-default4-WXUgJq",
  "confined2": "switch-81d9d7e1-confined2-WXUgJq",
  "confined10": "switch-81d9d7e1-confined10-WXUgJq",
  "default8": "switch-81d9d7e1-default8-WXUgJq",
  "confinedOffset5": "switch-81d9d7e1-confinedOffset5-WXUgJq",
  "tiny6": "switch-81d9d7e1-tiny6-WXUgJq",
  "confined11": "switch-81d9d7e1-confined11-WXUgJq",
  "wide7": "switch-81d9d7e1-wide7-WXUgJq",
  "xwide9": "switch-81d9d7e1-xwide9-WXUgJq",
  "confined12": "switch-81d9d7e1-confined12-WXUgJq",
  "xwide6": "switch-81d9d7e1-xwide6-WXUgJq",
  "default9": "switch-81d9d7e1-default9-WXUgJq",
  "xwide8": "switch-81d9d7e1-xwide8-WXUgJq",
  "xwideOffset2": "switch-81d9d7e1-xwideOffset2-WXUgJq",
  "tinyOffset7": "switch-81d9d7e1-tinyOffset7-WXUgJq",
  "grid": "switch-81d9d7e1-grid-WXUgJq",
  "default10": "switch-81d9d7e1-default10-WXUgJq",
  "confinedOffset10": "switch-81d9d7e1-confinedOffset10-WXUgJq",
  "xwide2": "switch-81d9d7e1-xwide2-WXUgJq",
  "wide2": "switch-81d9d7e1-wide2-WXUgJq",
  "xwideOffset9": "switch-81d9d7e1-xwideOffset9-WXUgJq",
  "defaultOffset11": "switch-81d9d7e1-defaultOffset11-WXUgJq",
  "confined1": "switch-81d9d7e1-confined1-WXUgJq",
  "xwideOffset5": "switch-81d9d7e1-xwideOffset5-WXUgJq",
  "xwideOffset7": "switch-81d9d7e1-xwideOffset7-WXUgJq",
  "tiny7": "switch-81d9d7e1-tiny7-WXUgJq",
  "confinedOffset4": "switch-81d9d7e1-confinedOffset4-WXUgJq",
  "xwideOffset4": "switch-81d9d7e1-xwideOffset4-WXUgJq",
  "wide4": "switch-81d9d7e1-wide4-WXUgJq",
  "confinedOffset11": "switch-81d9d7e1-confinedOffset11-WXUgJq",
  "wideGridContainer": "switch-81d9d7e1-wideGridContainer-WXUgJq",
  "confined9": "switch-81d9d7e1-confined9-WXUgJq",
  "xwideOffset11": "switch-81d9d7e1-xwideOffset11-WXUgJq",
  "tinyOffset8": "switch-81d9d7e1-tinyOffset8-WXUgJq",
  "xwide5": "switch-81d9d7e1-xwide5-WXUgJq",
  "wideOffset4": "switch-81d9d7e1-wideOffset4-WXUgJq",
  "tinyOffset11": "switch-81d9d7e1-tinyOffset11-WXUgJq",
  "defaultOffset2": "switch-81d9d7e1-defaultOffset2-WXUgJq",
  "wide12": "switch-81d9d7e1-wide12-WXUgJq",
  "wideOffset6": "switch-81d9d7e1-wideOffset6-WXUgJq",
  "confinedOffset8": "switch-81d9d7e1-confinedOffset8-WXUgJq",
  "wideOffset0": "switch-81d9d7e1-wideOffset0-WXUgJq",
  "tiny4": "switch-81d9d7e1-tiny4-WXUgJq",
  "wideOffset11": "switch-81d9d7e1-wideOffset11-WXUgJq",
  "xwideOffset10": "switch-81d9d7e1-xwideOffset10-WXUgJq",
  "wide10": "switch-81d9d7e1-wide10-WXUgJq",
  "col": "switch-81d9d7e1-col-WXUgJq",
  "tiny2": "switch-81d9d7e1-tiny2-WXUgJq",
  "xwide4": "switch-81d9d7e1-xwide4-WXUgJq",
  "confinedOffset1": "switch-81d9d7e1-confinedOffset1-WXUgJq",
  "wideOffset9": "switch-81d9d7e1-wideOffset9-WXUgJq",
  "xwide3": "switch-81d9d7e1-xwide3-WXUgJq",
  "confined6": "switch-81d9d7e1-confined6-WXUgJq",
  "confinedOffset9": "switch-81d9d7e1-confinedOffset9-WXUgJq",
  "xwide7": "switch-81d9d7e1-xwide7-WXUgJq",
  "defaultOffset1": "switch-81d9d7e1-defaultOffset1-WXUgJq",
  "tinyOffset9": "switch-81d9d7e1-tinyOffset9-WXUgJq",
  "confined5": "switch-81d9d7e1-confined5-WXUgJq",
  "wide1": "switch-81d9d7e1-wide1-WXUgJq",
  "xwideOffset3": "switch-81d9d7e1-xwideOffset3-WXUgJq",
  "tiny0": "switch-81d9d7e1-tiny0-WXUgJq",
  "default1": "switch-81d9d7e1-default1-WXUgJq",
  "confined3": "switch-81d9d7e1-confined3-WXUgJq",
  "default3": "switch-81d9d7e1-default3-WXUgJq",
  "xwide10": "switch-81d9d7e1-xwide10-WXUgJq",
  "tinyOffset1": "switch-81d9d7e1-tinyOffset1-WXUgJq",
  "xwideOffset8": "switch-81d9d7e1-xwideOffset8-WXUgJq",
  "tiny9": "switch-81d9d7e1-tiny9-WXUgJq",
  "tiny11": "switch-81d9d7e1-tiny11-WXUgJq",
  "confinedOffset2": "switch-81d9d7e1-confinedOffset2-WXUgJq",
  "tiny5": "switch-81d9d7e1-tiny5-WXUgJq",
  "tinyOffset5": "switch-81d9d7e1-tinyOffset5-WXUgJq",
  "defaultOffset6": "switch-81d9d7e1-defaultOffset6-WXUgJq",
  "xwide11": "switch-81d9d7e1-xwide11-WXUgJq",
  "tinyOffset3": "switch-81d9d7e1-tinyOffset3-WXUgJq",
  "confined7": "switch-81d9d7e1-confined7-WXUgJq",
  "standardGridContainer": "switch-81d9d7e1-standardGridContainer-WXUgJq",
  "default7": "switch-81d9d7e1-default7-WXUgJq",
  "defaultOffset5": "switch-81d9d7e1-defaultOffset5-WXUgJq",
  "default11": "switch-81d9d7e1-default11-WXUgJq",
  "wideOffset5": "switch-81d9d7e1-wideOffset5-WXUgJq",
  "xwideOffset1": "switch-81d9d7e1-xwideOffset1-WXUgJq",
  "row": "switch-81d9d7e1-row-WXUgJq",
  "defaultOffset4": "switch-81d9d7e1-defaultOffset4-WXUgJq",
  "defaultOffset3": "switch-81d9d7e1-defaultOffset3-WXUgJq",
  "wide3": "switch-81d9d7e1-wide3-WXUgJq",
  "gridContainer": "switch-81d9d7e1-gridContainer-WXUgJq",
  "default0": "switch-81d9d7e1-default0-WXUgJq",
  "confinedOffset0": "switch-81d9d7e1-confinedOffset0-WXUgJq",
  "tiny8": "switch-81d9d7e1-tiny8-WXUgJq",
  "tiny10": "switch-81d9d7e1-tiny10-WXUgJq",
  "tinyOffset4": "switch-81d9d7e1-tinyOffset4-WXUgJq",
  "confinedOffset7": "switch-81d9d7e1-confinedOffset7-WXUgJq",
  "tiny3": "switch-81d9d7e1-tiny3-WXUgJq",
  "wide8": "switch-81d9d7e1-wide8-WXUgJq",
  "wideOffset1": "switch-81d9d7e1-wideOffset1-WXUgJq",
  "xwide1": "switch-81d9d7e1-xwide1-WXUgJq",
  "xwide12": "switch-81d9d7e1-xwide12-WXUgJq",
  "default12": "switch-81d9d7e1-default12-WXUgJq",
  "default6": "switch-81d9d7e1-default6-WXUgJq",
  "tinyOffset2": "switch-81d9d7e1-tinyOffset2-WXUgJq",
  "xwideOffset6": "switch-81d9d7e1-xwideOffset6-WXUgJq",
  "wide0": "switch-81d9d7e1-wide0-WXUgJq",
  "default2": "switch-81d9d7e1-default2-WXUgJq",
  "wide5": "switch-81d9d7e1-wide5-WXUgJq",
  "tinyOffset0": "switch-81d9d7e1-tinyOffset0-WXUgJq",
  "wideOffset2": "switch-81d9d7e1-wideOffset2-WXUgJq",
  "defaultOffset7": "switch-81d9d7e1-defaultOffset7-WXUgJq",
  "tinyOffset6": "switch-81d9d7e1-tinyOffset6-WXUgJq",
  "confined8": "switch-81d9d7e1-confined8-WXUgJq",
  "tiny12": "switch-81d9d7e1-tiny12-WXUgJq",
  "confinedOffset6": "switch-81d9d7e1-confinedOffset6-WXUgJq",
  "wide6": "switch-81d9d7e1-wide6-WXUgJq",
  "wide11": "switch-81d9d7e1-wide11-WXUgJq",
  "wideOffset7": "switch-81d9d7e1-wideOffset7-WXUgJq",
  "confined0": "switch-81d9d7e1-confined0-WXUgJq",
  "confinedOffset3": "switch-81d9d7e1-confinedOffset3-WXUgJq",
  "confined4": "switch-81d9d7e1-confined4-WXUgJq",
  "wideOffset3": "switch-81d9d7e1-wideOffset3-WXUgJq",
  "default5": "switch-81d9d7e1-default5-WXUgJq",
  "defaultOffset8": "switch-81d9d7e1-defaultOffset8-WXUgJq",
  "defaultOffset9": "switch-81d9d7e1-defaultOffset9-WXUgJq",
  "wide9": "switch-81d9d7e1-wide9-WXUgJq",
  "tinyOffset10": "switch-81d9d7e1-tinyOffset10-WXUgJq",
  "armstrongGridContainer": "switch-81d9d7e1-armstrongGridContainer-WXUgJq",
  "wideOffset8": "switch-81d9d7e1-wideOffset8-WXUgJq",
  "wideOffset10": "switch-81d9d7e1-wideOffset10-WXUgJq",
  "xwide0": "switch-81d9d7e1-xwide0-WXUgJq",
  "xwideOffset0": "switch-81d9d7e1-xwideOffset0-WXUgJq"
};